import React from 'react';

import { IconProps } from './type';

export default function LocationIcon({
  size,
  className,
  ...props
}: React.ComponentProps<'svg'> & IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75623 8.75195C3.75623 7.49217 4.25667 6.28399 5.14747 5.3932C6.03827 4.5024 7.24645 4.00195 8.50623 4.00195C9.766 4.00195 10.9742 4.5024 11.865 5.3932C12.7558 6.28399 13.2562 7.49217 13.2562 8.75195C13.2562 10.0117 12.7558 11.2199 11.865 12.1107C10.9742 13.0015 9.766 13.502 8.50623 13.502C7.24645 13.502 6.03827 13.0015 5.14747 12.1107C4.25667 11.2199 3.75623 10.0117 3.75623 8.75195ZM8.50623 5.50195C7.64427 5.50195 6.81762 5.84436 6.20813 6.45386C5.59864 7.06335 5.25623 7.89 5.25623 8.75195C5.25623 9.61391 5.59864 10.4406 6.20813 11.05C6.81762 11.6595 7.64427 12.002 8.50623 12.002C9.36818 12.002 10.1948 11.6595 10.8043 11.05C11.4138 10.4406 11.7562 9.61391 11.7562 8.75195C11.7562 7.89 11.4138 7.06335 10.8043 6.45386C10.1948 5.84436 9.36818 5.50195 8.50623 5.50195Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0302357 7.60895C0.201162 5.53576 1.14546 3.60264 2.67565 2.19343C4.20584 0.784209 6.21 0.00194679 8.29024 0.00195313H8.72224C10.8025 0.00194679 12.8066 0.784209 14.3368 2.19343C15.867 3.60264 16.8113 5.53576 16.9822 7.60895C17.1724 9.91824 16.459 12.2112 14.9922 14.005L10.1992 19.866C9.99412 20.1168 9.73582 20.3189 9.44303 20.4577C9.15024 20.5965 8.83026 20.6685 8.50624 20.6685C8.18221 20.6685 7.86224 20.5965 7.56944 20.4577C7.27665 20.3189 7.01836 20.1168 6.81324 19.866L2.02024 14.005C0.553352 12.2113 -0.160079 9.91825 0.0302357 7.60895ZM8.29024 1.50195C6.58672 1.50221 4.94557 2.14298 3.69256 3.29707C2.43954 4.45117 1.66627 6.0342 1.52624 7.73195C1.36784 9.65381 1.96152 11.5621 3.18224 13.055L7.97524 18.917C8.03967 18.9958 8.12083 19.0594 8.21283 19.103C8.30484 19.1466 8.4054 19.1693 8.50724 19.1693C8.60907 19.1693 8.70963 19.1466 8.80164 19.103C8.89365 19.0594 8.9748 18.9958 9.03924 18.917L13.8322 13.055C15.0522 11.5618 15.6452 9.65355 15.4862 7.73195C15.3462 6.03403 14.5728 4.45085 13.3195 3.29673C12.0663 2.14262 10.4249 1.50196 8.72124 1.50195H8.29024Z"
        fill="currentColor"
      />
    </svg>
  );
}
